import { createIcon } from '../createIcon';
import { ReactComponent as IconHistory } from '../svg/history.svg';

export default createIcon(IconHistory);
